import { StoreState } from '@/redux/types';
import { getProductType } from './getProductType';

export const getProductTypeId = (state: StoreState) => getProductType(state).id;
